import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { AddressResult, AddressService } from 'app/services/address.service';

import { transform } from 'ol/proj';

@Component({
  selector: 'app-feat-address-search',
  templateUrl: './feat-address-search.component.html',
  styleUrls: ['./feat-address-search.component.css']
})
export class FeatAddressSearchComponent implements OnInit {

	addressStr = '';

	showAddressList = false;

	addressList: AddressResult[] = [];

	isSearchFocused = false;

	@Output('selectAddress') selectAddress: EventEmitter<AddressResult> = new EventEmitter();

	constructor(
		private elemRef: ElementRef,
		private addressService: AddressService
	) { }

	@HostListener('document:click', ['$event'])
	onDocumentClick(e: MouseEvent): void {
		if (e.target && !this.elemRef.nativeElement.contains(e.target)) {
			this.toggleAddressList(false);
		}
	}

	async searchAddress() {
		// Clear previous marker
		// this.mapService.removePlaceMarker(); // TODO
		//
		const addressStr = this.addressStr;
		// Check if the address is LatLong
		let latlong;
		if (typeof(addressStr) === 'string') {
			//remove whitespace and comma at 
			const trimedString = addressStr.replace(/^[,\s]+|[,\s]+$/g, '').replace(/\s\s+/g, ' ');				
			latlong = this.addressService.isLatLongDecimal(trimedString);
			if (!latlong) {
				latlong = this.addressService.isLatLongDMS(trimedString);
			}
		}
		if (latlong) {
			const coord = transform(latlong,'EPSG:4326','EPSG:3857');
			this.addressList = [{
				addr: latlong,
				coord: coord
			}];
		} else {
			// this.addressList = [];// TODO
			this.addressList = await this.addressService.searchAddressByGoogle(addressStr);
		}
		// this.addressList = this.addressList.concat([{
		// 	addr: 'test1'
		// }, {
		// 	addr: 'test2'
		// }])
		// If only one result is returned, pick that result
		if (this.addressList.length === 1) {
			this.selectAddress.emit(this.addressList[0]);
		} else {
			this.toggleAddressList(true);			
		}
	}
	selectAddressFromList(address: AddressResult) {
		this.toggleAddressList(false);
		this.selectAddress.emit(address);
	}

	private toggleAddressList(isShow) {
		this.showAddressList = isShow;
	}

	ngOnInit() {
	}

}
